import { useEffect } from 'react';
import { useOfflineNotification } from './hooks/useOfflineNotification';
import { Notification } from './Notifications/types';
import { getAppEnv } from './utils/env-utils';
import { isDevRuntime, isStagingRuntime, isTestRuntime } from '../common/utils';
import { useNotificationContext } from './contexts/NotificationContext/NotificationContext';

const environmentNotification: (
  appEnv: string | undefined
) => Notification = appEnv => ({
  id: 'environment-notification',
  message: `APP_ENV: ${appEnv}`,
  hideAutomatically: true,
});

export const SystemNotifications = () => {
  const { pushNotification: showNotification } = useNotificationContext();
  useEffect(() => {
    if (isStagingRuntime() || isTestRuntime() || isDevRuntime()) {
      showNotification(environmentNotification(getAppEnv()));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useOfflineNotification();
  return null;
};
